import { DataType } from '../../../Potential/SalesPotential/@types/ISalesPotentialTileData'

export type PotentialLabels = {key: DataType, value: string}[];

export const potentialLabels: PotentialLabels = [
  {
    key: 'citySize',
    value: 'placeme.well_fit_potential_tile.radar.city_size',
  },
  {
    key: 'competitors',
    value: 'placeme.well_fit_potential_tile.radar.competitors',
  },
  {
    key: 'population',
    value: 'placeme.well_fit_potential_tile.radar.population',
  },
  {
    key: 'tgFitLovers',
    value: 'placeme.well_fit_potential_tile.radar.tg_fit_lovers',
  },
  {
    key: 'traffic',
    value: 'placeme.well_fit_potential_tile.radar.traffic',
  },
]

export const similarLocationlabels = [
  'placeme.well_fit.potential.similar_location.table_label_1',
  'placeme.well_fit.potential.similar_location.table_label_2',
]
